import { statusType } from '../components/StatusBar/statusType'

/**
 * Monta as props da badge de status a partir do status cru.
 *
 * Existe porque essas duas linhas estavam repetidas em onze lugares — tabelas,
 * detalhes, barras —, e uma cor que valha para um status precisava ser mudada
 * nos onze. `tagColor` só viaja quando o status pede cor própria; sem ele a
 * badge continua traduzindo a variante de alerta, como sempre fez.
 *
 * O parâmetro é `string` porque é o que chega da API, e porque anunciar
 * `CampaignStatus | string` seria redundante: a união colapsa em `string`.
 */
export const campaignStatusBadge = (
  status?: string | null
): StatusData<string> => {
  const entry = status ? statusType[status as CampaignStatus] : undefined

  return {
    label: entry?.label || status || '',
    type: entry?.color || 'default',
    tagColor: entry?.tagColor
  }
}
